import { clsx } from 'clsx'
import { type FC, type ReactElement } from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'

import { Rating } from 'base-ui'

import { type ProductReviewListReviewEntryProps } from './ProductReviewListReviewEntryProps'
import { ProductReviewListReviewEntryTruncatedMessage } from './ProductReviewListReviewEntryTruncatedMessage'

const SHOP_APOTHEKE_SELLER_NAME = 'SHOP APOTHEKE'
const SELLER_REPLY_TYPE_OPERATOR = 'OPERATOR'

const renderDate = (date?: string): ReactElement => (
  <FormattedDate day="2-digit" month="2-digit" value={date} year="numeric" />
)

const ProductReviewsListReviewEntry: FC<ProductReviewListReviewEntryProps> = ({
  review,
  truncateLongComments = false,
}) => {
  return (
    <article>
      <div className="mb-2 flex flex-col tablet:flex-row tablet:items-center">
        <Rating
          className="mb-2 text-3xl tablet:mb-0"
          readOnly
          value={review.rating}
        />
        <h3 className="text-m font-medium tablet:ml-2.5">{review.title}</h3>
      </div>
      <h4 className="mb-2.5 text-xs font-medium">
        <FormattedMessage id="userReview.label.byCustomer" />{' '}
        {(review.customerName?.length ?? 0) > 0 ? (
          review.customerName
        ) : (
          <FormattedMessage id="userReview.label.fromOneCostumer" />
        )}{' '}
        <FormattedMessage id="userReview.label.onDate" />{' '}
        {renderDate(review.submissionDate)}
      </h4>
      <ProductReviewListReviewEntryTruncatedMessage
        initiallyTruncated={truncateLongComments}
        message={review.message}
      />
      {review.reply ? (
        <div
          className={clsx(
            'mt-2 rounded-s bg-light-primary-medium py-3.5 pl-5 pr-3.5',
            review.reply.type === SELLER_REPLY_TYPE_OPERATOR &&
              'bg-light-brand-medium',
          )}
        >
          <small className="font-bold">
            <FormattedMessage
              id="sellerReview.label.replyedBy.replyedOn"
              values={{
                date: renderDate(review.reply.replyDate),
                seller:
                  review.reply.type === SELLER_REPLY_TYPE_OPERATOR
                    ? SHOP_APOTHEKE_SELLER_NAME
                    : review.reply.responder,
              }}
            />
          </small>
          <ProductReviewListReviewEntryTruncatedMessage
            className="mt-3.5"
            initiallyTruncated={truncateLongComments}
            message={review.reply.comment}
          />
        </div>
      ) : null}
    </article>
  )
}

export { ProductReviewsListReviewEntry }
